import React from "react";
import styled from "styled-components";
import getImageURL from "../../../../controllers/getImageURL";
import formatDate from "../../../../controllers/formatDate";
import SemanticButton from "../../../helperComponents/SemanticButton";
import { useTranslation } from "react-i18next";

const Card = styled.div`
  border-radius: 15px;
  width: 350px;
  overflow: hidden;
  color: white;
  position: relative;
  transition: all 0.25s ease-in-out;
  cursor: pointer;

  &:hover {
    transform: scale(0.95);
  }

  background: var(--surface);
  border: 1px solid var(--border);
  color: var(--element);

  @media (max-width: 900px) {
    width: 90vw;
  }
`;

const ImageContainer = styled.div`
  width: 100%;
  height: 250px;
  overflow: hidden;
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const Badge = styled.div`
  position: absolute;
  top: 15px;
  left: 15px;
  background-color: #303030;
  padding: 5px 15px;
  border-radius: 20px;
  font-size: 14px;
  color: var(--element);
  font-weight: bold;
`;

const InfoContainer = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const Title = styled.h2`
  font-size: 18px;
  font-weight: bold;
  text-align: left;
  color: var(--element);
  margin: 0;
`;

const Subtitle = styled.p`
  font-size: 14px;
  font-weight: 700;
  opacity: 0.5;
  text-transform: capitalize;
  color: var(--element);
  margin: 0;
  width: 95%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export default function AnnouncementCard({ item }) {
  const { t } = useTranslation();

  return (
    <SemanticButton href={`/announcement/?itemID=${item._id}`}>
      <Card>
        <ImageContainer>
          <Image src={getImageURL(item.image)} alt="" />
        </ImageContainer>
        <InfoContainer>
          <Title>{item.title}</Title>
          <Subtitle>{item.description}</Subtitle>
        </InfoContainer>
      </Card>
    </SemanticButton>
  );
}
